import { EmbedWidgetData, IEmbedWidgetData } from "@pageBuilder/typings";
import { WidgetRendererBase } from "./widget-renderer-base";

export class EmbedWidgetRenderer extends WidgetRendererBase<IEmbedWidgetData> {

    protected createNewInternal(): HTMLElement {
        const element = this.createWidgetElement("embedWidget");
        element.classList.add("embed");

        return element;
    }

    protected renderInternal(element: HTMLElement, data: IEmbedWidgetData): HTMLElement {
        if (this.isEditorRendering) {
            this.renderPlaceholder(element);
        } else {
            const content = element.querySelector(".widget-content") as HTMLElement;
            content?.remove();
            if (data.embedType === "iframe") {
                const iFrame = document.createElement("iframe");
                iFrame.src = data.code;
                iFrame.title = data.title;
                iFrame.width = "100%";
                iFrame.height = "100%";
                element.appendChild(iFrame);
            } else {
                element.style.removeProperty("height");
                element.innerHTML = data.code;
                this.executeScripts(element);
            }
        }

        this.setClassByEmbedType(element, data.embedType);
        this.renderStyles(element, data);

        return element;
    }

    private renderPlaceholder(element: HTMLElement): void {
        const content = element.querySelector(".widget-content") as HTMLElement;
        let notAvailableElement = element.querySelector<HTMLDivElement>(".not-available");
        if (!notAvailableElement) {
            notAvailableElement = document.createElement("div");
            notAvailableElement.classList.add("not-available");
            content.appendChild(notAvailableElement);
        }
    }

    protected renderStyles(element: HTMLElement, data: IEmbedWidgetData): void {
        if (data.embedType === "code") {
            element.style.removeProperty("min-height");
        }

        this.renderBaseStyles(element, data);
    }

    private renderBaseStyles(element: HTMLElement, data: IEmbedWidgetData): void {
        if (data.style?.heightData?.height) {
            if (data.embedType === "code") {
                data.style.heightData.height = 128;
                if (this.isEditorRendering) {
                    element.style.height = `${data.style.heightData.height}px`;
                }
            } else {
                element.style.height = `${data.style.heightData.height}px`;
            }
        } else {
            element.style.height = `128px`;
        }

        this.animationRenderer.setAnimationStyles(element, data.style?.animation);
    }

    private setClassByEmbedType(element: HTMLElement, embedType: "code" | "iframe"): void {
        element.classList.remove("code", "iframe");
        element.classList.add(embedType);
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`];
    }

    protected override isEmpty(widget: HTMLElement): boolean {
        const isCodeType = widget.classList.contains("code");
        if (isCodeType) {
            return widget.innerHTML === EmbedWidgetData.defaultData.code;
        }

        const iframe = widget.querySelector("iframe");
        return iframe?.getAttribute("src")?.length === 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
